import { render, staticRenderFns } from "./HistoryControls.vue?vue&type=template&id=3cf9e153&scoped=true"
import script from "./HistoryControls.vue?vue&type=script&lang=ts"
export * from "./HistoryControls.vue?vue&type=script&lang=ts"
import style0 from "./HistoryControls.vue?vue&type=style&index=0&id=3cf9e153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9e153",
  null
  
)

export default component.exports